<template>
  <div :class="classes()"></div>
</template>

<script>
export default {
  name: 'Divider',
  props: {
    dotted: Boolean,
    direction: {
      type: String,
      default: 'horizontal',
      validator: (val) => ['horizontal', 'vertical'].includes(val),
    },
  },
  data() {
    return {
      el: 'o-divider',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--dotted`]: this.dotted,
          [`${el}--${this.direction}`]: this.direction,
        };
      },
    };
  },
};
</script>
